import Vue from "vue"
import Vuex from "vuex"
import app from "./modules/app"
import user from "./modules/user"
import marques from "./modules/marques"
import supports from "./modules/supports"
import supportstypes from "./modules/supportstypes"
import categories from "./modules/categories"
import thematiques from "./modules/thematiques"
import videos from "./modules/videos"
import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
//
import permissions from "./modules/permissions"

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},
  modules: {
    app,
    user,
    thematiques,
    marques,
    supports,
    supportstypes,
    categories,
    videos,
    permissions
  },
  actions,
  getters,
  mutations
})

export default store
